<template>
  <v-dialog
    v-model="showModal"
    max-width="700"
    persistent
  >
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert
          type="error"
        >
          {{ errorMessage }}
        </v-alert>
      </template>
      <validation-observer 
        ref="validator"
        v-slot="{ handleSubmit }"
      >
        <v-card-title class="text-sm-left font-weight-bold">
          <template v-if="isCreate">
            Thêm mới Zalo
          </template>
          <template v-else>
            Cập nhật thông tin Zalo
          </template>

          <v-spacer />

          <v-icon
            aria-label="Close"
            @click="hideModal"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <p><b>Tên Zalo khách hàng: </b>{{ zaloContact.name }}</p>
          <validation-provider
            v-slot="{ errors }"
            class="mb-2"
            rules="required|max:10|min:9|alpha_num"
            name="SDT follow Zalo"
          >
            <v-text-field
              v-model="zaloContact.mobile"
              label="SDT follow Zalo *"
              :error-messages="errors"
              color="primary"
            />
          </validation-provider>

        </v-card-text>

        <v-card-actions class="px-0 group-btn--form">
          <v-btn
            color="success"
            @click.prevent="handleSubmit(saveZaloContact)"
          >
            Lưu lại
          </v-btn>
          <v-btn
            class="ml-0"
            color="primary"
            @click="hideModal"
          >
            Hủy bỏ
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  const ZaloRepository = RepositoryFactory.get('zalo')

  export default {
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      schoolLevels: {
        type: Array,
        default: () => {[]}
      }
    },
    data () {
      return {
        showModal: false,
        zaloContact: {},
        isCreate: true,
        datazaloContacts: [],
        errorMessage: '',
        listURL: [],
        urlsItem: [],
        warehouseOptions: [
          {
            text: 'Marketing',
            value: 'marketing'
          },
          {
            text: 'Sale',
            value: 'sale'
          }
        ]
      }
    },
    created () {
      Bus.$on('zalo-show-form', (datazaloContact) => {
        this.showModal = true
        const { urls = [] } = datazaloContact
        if (urls.length === 0) {
          datazaloContact.urls = [{
            id: (new Date()).getTime(),
            inputUrl: '',
          }]
        }
        this.zaloContact = _.cloneDeep(datazaloContact)
        if (datazaloContact.id) this.isCreate = false
        else this.isCreate = true
        this.getListURL()
      })
    },
    methods: {
      hideModal: function () {
        this.showModal = false
        this.isCreate = true
        this.errorMessage = ''
        this.$refs.validator.reset()
      },
      addRow () {
        const datazaloContact = _.cloneDeep(this.zaloContact)
        const { urls = [] } = datazaloContact
        urls.push({
          id: (new Date()).getTime(),
          inputUrl: '',
        })
        this.$set(this, 'zaloContact', datazaloContact)
      },
      deleteRow (id) {
        const index = this.zaloContact.urls.findIndex(u => u.id === id)
        if (index > -1) this.zaloContact.urls.splice(index, 1)
      },
      async saveZaloContact () {
        const datazaloContact = {
          mobile: _.trim(this.zaloContact.mobile)
        }
        const loader = this.$loading.show()
        let response = {}
        // if (this.isCreate) {
        //   response = await ZaloRepository.create(datazaloContact)
        //   loader.hide()
        //   if (!response.success) {
        //     this.errorMessage = _.get(response, 'message', '')
        //   } else {
        //     this.errorMessage = ''
        //     this.showModal = false
        //     this.$swal({
        //       title: 'Thêm Zalo thành công',
        //       confirmButtonText: 'Đồng ý',
        //     }).then(() => {
        //       Bus.$emit('zalo-reload')
        //     })
        //   }
        // } else {
          response = await ZaloRepository.update(this.zaloContact.user_social_id, datazaloContact)
          loader.hide()
          if (!response.success) {
            this.errorMessage = _.get(response, 'message', '')
          } else {
            this.errorMessage = ''
            this.showModal = false
            this.$swal({
              title: 'Cập nhật Zalo thành công',
              confirmButtonText: 'Đồng ý',
            }).then(() => {
              Bus.$emit('zalo-reload')
            })
          }
        // }
      },

      async getListURL () {
        const listURL = []
        const responseURL = await ZaloRepository.list({limit: 10000})
        if (responseURL.success) {
          _.get(responseURL, 'data', []).map(item => {
            _.get(item, 'urls', []).map(url => (
              listURL.push(url.url)
            ))
          })
        } else {

        }
        this.listURL = listURL

        const urlsItem = this.zaloContact.urls.map(e => e.inputUrl)
        this.urlsItem = urlsItem

        _.pull(this.listURL, ...urlsItem)
      }
    },
  }
</script>
